module.exports = __webpack_public_path__ + "img/appAsset-ui--security.d64747bc.svg";